<template>
  <v-container class="fill-height addadvertiser" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" md="12">
        <v-card class="elevation-12">
<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
            <!---- Start Preview ---->
            <v-row align="center" justify="center">
            <v-col cols="12" sm="12" md="12">
            <div class="row justify-content-center border py-5">
              <table width="95%" style="border:1px solid #b3d4fc;">
                <tr>
                  <td colspan="3">
                      <div class="header-content padding-right-0">
                        <div class="col-12 padding-right-0">
                            <img width="100%"  :src="topheader" >
                        </div>
                      </div>  
                    </td>  
                </tr>
                <tr>
                  <td colspan="2">
                          <div class="col-2 padding-right-0">
                            <img width="100%"  :src="topheaderleft" >
                            </div> 
                    </td>
                   <td colspan="2">
                         <div v-if="bannerposition=='headercontent'">
                            <div class="bannercontenthtml bannercontentimage" v-html="bannercontent">
                                  </div>
                          </div>
                          <div v-else>
                            <img width="100%"  :src="topheaderright" >
                          </div>  
                    </td>     
                </tr>
                <tr>
                    <td colspan="3">
                   <div class="col-lg-12 col-md-12 padding-right-0 left-content">
                     <img class="leftsection" width="100%" :src="menubanner" >
                   </div>
                  </td>
                 </tr>
                  <tr>
                    <td style="vertical-align:top;" colspan="2">
                   <div  class="col-lg-12 col-md-12 padding-right-0 left-content">
                     <img  width="100%" :src="leftbannerone" >
                   </div>
                    <div  class="col-lg-12 col-md-12 mx-auto"  v-if="bannerposition=='leftcontent'">
                            <div style="margin:0 auto;" class="bannercontenthtml bannercontentimage" v-html="bannercontent">
                                  </div>
                      </div>
                  </td>
                   <td >
                   <div class="col-lg-12 col-md-12 padding-right-0 left-content">
                     <table width="100%">
                      <tr>
                        <td> 
                          <div class="col-lg-12 col-md-12 padding-right-0 left-content">
                            <img  width="100%" :src="rightbannerone" >
                          </div>
                        </td>
                      </tr> 
                      <tr>
                        <td> 
                           <div v-if="bannerposition=='rightcontent'">
                            <div  style="margin:0 auto;"  class="bannercontenthtml bannercontentimage" v-html="bannercontent">
                                  </div>
                          </div>
                          <div v-else>
                            <img  width="100%" :src="rightbannersecond" >
                          </div>
                        </td>
                      </tr>  
                      </table>
                   </div>
                  </td>
                 </tr>
                  <tr>
                   <td colspan="3" >
                         <div class="col-lg-12 col-md-12 padding-right-0 left-content">
                            <img  width="100%" :src="footerbanner" >
                          </div>    
                    </td>  
                </tr>  
            </table>   
            </div>
            </v-col>
        </v-row>
      <!---- End Preview ---->
      </v-col>
    </v-row>
  </v-container>
  </template>
  </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

import 'vue-form-wizard/dist/vue-form-wizard.min.css'

//var adserverURL ="http://local.adserver.com/www/";

  export default {
    name: 'Pi3cktemplate',
    props:[
       'bannerposition',
       'bannercontentimage',
       'bannercontenthtml',
       'bannercontent',
       'bannerimage',
    ],
    components: {
         
        },
    data: () => ({
      topheader : require("@/assets/mynewsimg1.png"),
      topheaderleft : require("@/assets/mynewsimg2.png"),
      topheaderright : require("@/assets/mynewsimg3.png"),
      menubanner : require("@/assets/mynewsimg4.png"),
      leftbannerone : require("@/assets/mynewsimg5.png"),
      rightbannerone : require("@/assets/mynewsimg6.png"),
      rightbannersecond : require("@/assets/mynewsimg7.png"),
      footerbanner : require("@/assets/mynewsimg8.png"),


      headersection : require("@/assets/mynews24-header.png"),
     // leftsection : require("@/assets/mynews24-middle.png"),
     middlesection:  require("@/assets/mynews24-middle.png"),
      rightsection :  require("@/assets/mynews24-footer.png"),
      adhere: require("@/assets/506.jpg"),
     }),
      mounted() {
        //this. defaultsection();
     },
   computed:{
     baseURL() {
              const url = process.env.VUE_APP_BASEAPI.slice(0, -4);
              return url;
            }
     },
    methods: { 
     checkMove: function(evt){
        this.$emit("update:bannerposition", evt.to.id);
    },  
    defaultsection()
    {
       this.$emit("update:bannerposition", "centercontent");
    }          
    }
  }
</script>
<style scoped>
.row {
  margin-left: 0px;
}
.padding-top-0{padding-top: 0px !important;}
.padding-right-0{padding-right: 0px !important;}
.padding-bottom-0{padding-bottom: 0px !important;}    
.draggable-list {
  color: #fff;
  border: 1px solid;
  height: 150px;
}
.header-content{width:100%;}
.left-content{padding-top:0px;padding-right:0px; }
.center-content{height: 100%;}
.right-content{height: 100%;}
.footer-content{height: 100%; border:1px solid #b3d4fc;}
.draggablecontent{background-size: 100% 100%;margin-top: 24%;width: 50%;margin-left: 25%;}
.bannercontentimage{width:150px;height:150px;position: relative;}

.postionsection{width: 100%;height: 150px;}
.leftsection{padding-bottom:16px;}
</style>